<template>
  <!-- <HelloWorld /> -->
  <div class="home">
    <!-- <h1 class="mx-3 my-3 font-weight-regular headline">Homepage</h1> -->


    <v-layout row wrap align-center justify-center class="mt-5">
      <v-flex xs12 sm6 md5 lg9>
        <v-hover>
        <v-card class="text-xs-center ma-3" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">
          <v-card-text>
            <div class="headline mb-3"> iVenture - A research tool for the Blitz Canvas framework</div>
            <v-layout align-center justify-center>
              <div
                class="welcome-text subheading"
              >
              <!-- front page -->


<p>You will be asked to open a URL and navigate through different options before completing the rest of the questions.</p>

<!-- <p>&nbsp;</p> -->

<p><strong>About the iVenture Tool</strong></p>

<!-- <p>&nbsp;</p> -->

<p>The iVenture tool is developed based on a conceptual model (called the “Blitz Canvas”) which allows aspiring entrepreneurs to create a business model around a product concept and get a prototype out to the market as early as possible. In this study we want to evaluate if the proposed tool (along with the underlying framework) helps the user create a business model using a step by step process driven approach, validate the value proposition and present the created business model in a visually appealing format.</p>

<!-- <p>&nbsp;</p> -->

<p>The data that is used in this tool is collected from online websites, and university handbook.</p>

<p>&nbsp;</p>

<p><strong>General Instructions</strong></p>

<!-- <p>&nbsp;</p> -->

<p style="text-align:center;"><font size='5'> Please visit the website </font> <br/> <font size='7'>‘<a href="http://iventure-v1.web.app/Bcprocessmodel">iventure-v1.web.app</a>’ </font> <br/><font size='5'> in chrome or firefox browser and please choose the option “Let’s work on a business model” </font></p>

<p>&nbsp;</p>

<p>In order to demonstrate the working of the iVenture tool to the user of the tool, the screens in each web page present pre-filled details for a business model built around an imaginary online Todo-list product. The business model is built in 10 steps and then the dashboard of the business model will be available for the user’s review.</p>

<p>&nbsp;</p>

<p>Step 1: Clicking on the <span style="font-variant: normal"><span style="letter-spacing: normal"><em><strong>Build the foundation</strong></em></span></span> option will enable the users to add foundational details of the startup such as mission, vision, goals, core competence and core cultural aspect.</p>

<!-- <p>&nbsp;</p> -->

<p><span lang="en-US">Step 2: </span><span lang="en-US">Click</span><span lang="en-US">ing</span><span lang="en-US"> on the </span><span style="font-variant: normal"><span style="letter-spacing: normal"><span lang="en-US"><em><strong>Studying the User</strong></em></span></span></span><span lang="en-US"> </span><span lang="en-US">option</span><span lang="en-US"> </span><span lang="en-US">will enable the users to </span><span lang="en-US">study the user via their user persona profile and user stories</span><span lang="en-US">.</span><br>
<br>
<span lang="en-US">Step </span><span lang="en-US">3</span><span lang="en-US">: </span><span lang="en-US">Click</span><span lang="en-US">ing</span><span lang="en-US"> on the </span><span style="font-variant: normal"><span style="letter-spacing: normal"><span lang="en-US"><em><strong>Defining the solution</strong></em></span></span></span><span lang="en-US"> </span><span lang="en-US">option</span><span lang="en-US"> </span><span lang="en-US">will </span><span lang="en-US">help users define the product’s goals and features, along with adding a link to the prototype wireframe of the tool</span><span lang="en-US">.</span><br>
<br>
<span lang="en-US">Step 4: </span><span lang="en-US">Click</span><span lang="en-US">ing</span><span lang="en-US"> on the </span><span style="font-variant: normal"><span style="letter-spacing: normal"><span lang="en-US"><em><strong>Unique selling proposition</strong></em></span></span></span><span lang="en-US"> </span><span lang="en-US">option</span><span lang="en-US"> </span><span lang="en-US">will </span><span lang="en-US">help shape the differentiating factor for the product</span><span lang="en-US">.</span><br>
<br>
<span lang="en-US">Step </span><span lang="en-US">5</span><span lang="en-US">: </span><span lang="en-US">Click</span><span lang="en-US">ing</span><span lang="en-US"> on the </span><span style="font-variant: normal"><span style="letter-spacing: normal"><span lang="en-US"><em><strong>User's thoughts on the solution</strong></em></span></span></span><span lang="en-US"> </span><span lang="en-US">option</span><span lang="en-US"> </span><span lang="en-US">will </span><span lang="en-US">let the user gather feedback of product from end-users of the product</span><span lang="en-US">.</span><br>
<br>
<span lang="en-US">Step </span><span lang="en-US">6</span><span lang="en-US">: </span><span lang="en-US">Click</span><span lang="en-US">ing</span><span lang="en-US"> on the</span><span lang="en-US"> </span><span style="font-variant: normal"><span style="letter-spacing: normal"><span lang="en-US"><em><strong>The C</strong></em></span></span></span><span style="font-variant: normal"><span style="letter-spacing: normal"><span lang="en-US"><em><strong>ompetition</strong></em></span></span></span><span lang="en-US"> </span><span lang="en-US">option</span><span lang="en-US"> </span><span lang="en-US">will </span><span lang="en-US">let the users study the competition offering similar products, in the context of the features they offer</span><span lang="en-US">.</span><br>
<br>
<span lang="en-US">Step </span><span lang="en-US">7</span><span lang="en-US">: Click</span><span lang="en-US">ing</span><span lang="en-US"> on the</span><span lang="en-US"> </span><span style="font-variant: normal"><span style="letter-spacing: normal"><span lang="en-US"><em><strong>Business modeling</strong></em></span></span></span><span lang="en-US"> </span><span lang="en-US">option</span><span lang="en-US"> </span><span lang="en-US">will </span><span lang="en-US">let the users </span><span lang="en-US">define the business elements, along with aspects such as intellectual property and selection of software as a service solutions</span><span lang="en-US">.</span><br>
<br>
<span lang="en-US">Step </span><span lang="en-US">8</span><span lang="en-US">: Clicking on the </span><span style="font-variant: normal"><span style="letter-spacing: normal"><span lang="en-US"><em><strong>Synergies </strong></em></span></span></span><span lang="en-US">option</span><span lang="en-US"> </span><span lang="en-US">will </span><span lang="en-US">enable to users to list the synergies between the various areas of the business</span><span lang="en-US">.</span><br>
<br>
<span lang="en-US">Step </span><span lang="en-US">9</span><span lang="en-US">: </span><span lang="en-US">Click</span><span lang="en-US">ing</span><span lang="en-US"> on the </span><span style="font-variant: normal"><span style="letter-spacing: normal"><span lang="en-US"><em><strong>Managing Growth </strong></em></span></span></span><span lang="en-US">option</span><span lang="en-US"> </span><span lang="en-US">will </span><span lang="en-US">enable to users to </span><span lang="en-US">plan for growth related aspects such as handling scale when the number of users increase and planning for newer innovative products which complement the current product offering</span><span lang="en-US">.</span></p>

<!-- <p>&nbsp;</p> -->

<p><span lang="en-US">Step </span><span lang="en-US">10</span><span lang="en-US">: </span><span lang="en-US">Click</span><span lang="en-US">ing</span><span lang="en-US"> on the </span><span lang="en-US"><em><strong>Metrics</strong></em></span><span style="font-variant: normal"><span style="letter-spacing: normal"><span lang="en-US"><em><strong> </strong></em></span></span></span><span lang="en-US">option</span><span lang="en-US"> </span><span lang="en-US">will </span><span lang="en-US">enable to </span><span lang="en-US">list metrics which will help track the health of the business once the model will materialize into an organization</span><span lang="en-US">.</span></p>

<p>&nbsp;</p>

<p>On completion of the above ten steps, you will be presented with an option to <em><strong>Finalize Business model</strong></em>, which will take you to a dashboard which presents the details of the business model categorized by model elements which deal with <em>why the product matter</em><em>s</em>, <em>capital related factors</em> and <em>getting the product to the market quickly</em>.</p>

<p>&nbsp;</p>

<p>Thank you for doing the tasks. Now please head to the next step and finish the survey.</p>






              </div>
            </v-layout>
          </v-card-text>

          <v-card-actions class="center">
            <v-layout column align-center justify-center>
              <v-btn dark color="primary" class="mb-3" href="http://iventure-v1.web.app/Bcprocessmodel">Let's get started!</v-btn>
              <!-- <v-btn class="mb-3" router to="/Home">Head back all options</v-btn> -->
              
            </v-layout>
          </v-card-actions>
        </v-card>
        </v-hover>



      </v-flex>




    </v-layout>


  </div>
</template>

<script>
// import HelloWorld from '../components/HelloWorld' Let's create my first product concept :)

export default {
  name: '',
  data(){
    return{ 
      
    }
  },
  components: {
    //HelloWorld
  }
};
</script>

<style>
.welcome-text {
  text-align: center;
}
</style>
